export default __webpack_public_path__ + "static/media/badge-award.96271751.svg";